import { User, UserSettings } from 'Models'

export function isExternalApiCustomerAccount() {
    const apiAccount = UserSettings.getApiAccount()

    return apiAccount !== undefined && apiAccount !== null && String(apiAccount).trim() !== ''
}

export function isInstitutionAttendeeAccount() {
    return User.exists() && User.current().belongsToInstitution()
}

export function isChatParticipationExcludedAccount() {
    return isInstitutionAttendeeAccount() || isExternalApiCustomerAccount()
}
